import { Box, Typography } from "@mui/material";
import {
  Edit,
  SimpleForm,
  TextInput,
  Datagrid,
  List,
  TextField,
  Create,
  DateInput,
  Show,
  SimpleShowLayout,
  DateField,
} from "react-admin";


const FirstPage = () => (
  <Box textAlign="center" padding={2}>
    <Typography variant="body2">Most Recent Support Cases</Typography>
  </Box>
);

export const CaseList = (props) => (
  <List {...props} sort={{ field: 'createdDate', order: 'DESC' }} perPage={10} pagination={<FirstPage />}>
    <Datagrid rowClick="edit" bulkActionButtons={false} >
      <DateField label="Created" source="createdDate" />
      <TextField label="Subject" source="subject" />
      <TextField label="Status" source="status" />
    </Datagrid>
  </List>
);

export const CaseShow = () => (
  <Show>
    <SimpleShowLayout>
      <DateField label="Created" source="createdDate" />
      <TextField label="Subject" source="subject" />
      <TextField label="Status" source="status" />
    </SimpleShowLayout>
  </Show>
);
